var map = {
	"./ebirah_full.png": 6024,
	"./ebirah_game.png": 5728,
	"./ebirah_moves.png": 9142,
	"./ebirah_side.png": 8669,
	"./general_game.png": 4063,
	"./general_side.png": 3979,
	"./giant_squid_full.png": 121,
	"./giant_squid_game.png": 2191,
	"./giant_squid_moves.png": 7080,
	"./giant_squid_side.png": 4764,
	"./jormungandr_full.png": 5547,
	"./jormungandr_game.png": 7784,
	"./jormungandr_moves.png": 2260,
	"./jormungandr_side.png": 9538,
	"./kraken_full.png": 744,
	"./kraken_game.png": 5913,
	"./kraken_moves.png": 6146,
	"./kraken_side.png": 9382,
	"./leviathan_full.png": 6466,
	"./leviathan_game.png": 585,
	"./leviathan_moves.png": 2629,
	"./leviathan_side.png": 4758,
	"./loch_ness_full.png": 9870,
	"./loch_ness_game.png": 9853,
	"./loch_ness_moves.png": 2842,
	"./loch_ness_side.png": 8360,
	"./megalodon_full.png": 8873,
	"./megalodon_game.png": 3088,
	"./megalodon_moves.png": 3796,
	"./megalodon_side.png": 7546,
	"./sea_hydra_full.png": 128,
	"./sea_hydra_game.png": 8456,
	"./sea_hydra_moves.png": 4815,
	"./sea_hydra_side.png": 6855,
	"./siren_full.png": 9071,
	"./siren_game.png": 3214,
	"./siren_moves.png": 6018,
	"./siren_side.png": 7968,
	"./white_whale_full.png": 371,
	"./white_whale_game.png": 1154,
	"./white_whale_moves.png": 8451,
	"./white_whale_side.png": 3045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;